document.addEventListener("DOMContentLoaded", () => {
  let mobileFacetOpen = false;

  const isFacetSearchInput = (target) =>
    target && target.classList && target.classList.contains("facet-merk-search");

  document.addEventListener("click", (event) => {
    const target = event.target;

    const toggleBtn = target.closest(".facets_hide");
    if (toggleBtn) {
      const panel = document.querySelector(".facets-inline-panel");
      const container = panel?.querySelector(".facets-container");
      const productList = document.querySelector(".collection-product-list, #product-grid-container");

      if (container) {
        const isHidden = container.classList.toggle("is-hidden");
        productList?.classList.toggle("filter-are-hidden");
        
        const span = toggleBtn.querySelector("span");
        if (span) {
          const hideText = span.dataset.hideText || "Hide Filter";
          const showText = span.dataset.showText || "Show Filter";
          span.textContent = isHidden ? showText : hideText;
        }
        toggleBtn.classList.toggle("is-open");
        panel.querySelector(".filter_title__heading")?.classList.toggle("filter_title__heading--hidden", isHidden);
      }
      return; 
    }

    const mobileToggle = target.closest(".mobile-facets-toggle");
    if (mobileToggle) {
      mobileFacetOpen = true;
      document.querySelector(".facets-inline-panel")?.classList.add("is-mobile-open");
      document.documentElement.style.overflow = "hidden";
    }

    if (target.closest(".facets_mobile_close, .filter_mobile_close")) {
      mobileFacetOpen = false;
      document.querySelector(".facets-inline-panel")?.classList.remove("is-mobile-open");
      document.documentElement.style.overflow = "";
    }
  });

  document.addEventListener("input", (event) => {
    if (isFacetSearchInput(event.target)) {
      const input = event.target;
      const targetSelector = input.dataset.target;
      const list = document.querySelector(targetSelector);
      if (!list) return;
      const query = input.value.trim().toLowerCase();
      list.querySelectorAll(".facets__item").forEach((item) => {
        const label = item.dataset.label || "";
        item.style.display = label.includes(query) ? "" : "none";
      });
    }
  }, true);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Enter" && isFacetSearchInput(event.target)) {
      event.preventDefault();
    }
  }, true);

  const runSetup = () => {
    const panel = document.querySelector(".facets-inline-panel");
    if (!panel) return;

    if (window.innerWidth <= 749) {
      panel.querySelectorAll("details").forEach((detail) => {
        if (!detail.classList.contains("facets__disclosure-price")) {
          detail.removeAttribute("open");
        }
      });
    }

    if (mobileFacetOpen) {
      panel.classList.add("is-mobile-open");
    }
  };

  const observer = new MutationObserver((mutations) => {
    let needsUpdate = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        needsUpdate = true;
        break;
      }
    }
    if (needsUpdate) runSetup();
  });

  const observerTarget = document.querySelector('main') || document.body;
  observer.observe(observerTarget, { childList: true, subtree: true });
  
  runSetup();
});
